import * as React from "react";
import Table from "@mui/material/Table";
import { ActividadContext } from "../../Context/ActividadContext";
import ActividadesTableBody from "./TableBody";
import {
  getComparator,
  stableSort,
} from "../../../../../Config/reuserFunctions";
import ActividadesTableHead from "./TableHead";
import { Paper } from "@mui/material";
import CustomContainer from "./CustomContainer";

export default function ActividadesTable() {
  const {
    itemsSelected,
    setItemsSelected,
    setIndeterminated,
    actividades,
    handleSaveActividad,
    newItem,
    setNewItem,
  } = React.useContext(ActividadContext);
  const [shadows, setShadows] = React.useState({
    start: "",
    end: "leftShadowTable",
  });
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("actividad");
  const tableEl = React.useRef();

  const renderActividadesSorted = React.useMemo(() => {
    return stableSort(actividades, getComparator(order, orderBy));
  }, [order, orderBy, actividades]);

  const changeClassName = React.useCallback((scrollLeft, realWidth) => {
    if (scrollLeft === 0) {
      setShadows({ start: "removeShadowTable", end: "leftShadowTable" });
      return;
    }
    if (scrollLeft === realWidth) {
      setShadows({ start: "rightShadowTable", end: "removeShadowTable" });
      return;
    }
    setShadows({ start: "rightShadowTable", end: "leftShadowTable" });
  }, []);

  const handleOnScroll = (ev) => {
    const { scrollLeft, scrollWidth, clientWidth } = ev.target;
    const realWidth = scrollWidth - clientWidth;
    changeClassName(scrollLeft, realWidth);
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelect = (checked, item) => {
    const items = [...itemsSelected];
    if (checked) items.push(item);
    if (!checked) {
      const indx = items.findIndex((elm) => elm._id === item._id);
      items.splice(indx, 1);
    }
    setItemsSelected(items);
    //revisar el checkAll
    if (items.length > 0 && items.length !== actividades.length) {
      setIndeterminated(true);
      return;
    }
    setIndeterminated(false);
  };

  const handleCheckAll = (checked) => {
    setIndeterminated(false);
    if (checked) {
      setItemsSelected(actividades);
      return;
    }
    setItemsSelected([]);
  };

  return (
    <Paper variant="outlined">
      <CustomContainer
        tableRef={tableEl}
        onScroll={handleOnScroll}
        onFocusInput={() =>
          newItem &&
          setNewItem((st) => {
            const { focusOn, ...state } = st;
            return state;
          })
        }
      >
        <form
          id="form-actividad-table"
          onSubmit={handleSaveActividad}
          style={{ height: "10px" }}
        >
          <Table stickyHeader size="small">
            <ActividadesTableHead
              handleSort={handleSort}
              order={order}
              orderBy={orderBy}
              handleCheckAll={handleCheckAll}
            />
            <ActividadesTableBody
              shadows={shadows}
              actividades={renderActividadesSorted}
              handleSelect={handleSelect}
            />
          </Table>
        </form>
      </CustomContainer>
    </Paper>
  );
}
